module.exports = __webpack_public_path__ + "img/9.4f77d72b.png";